import { Box, Button, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomTable } from "../../../../../../components"
import { RefTable } from "../../../../../../components/table/types"
import { useRef } from "react"
import { useContextState } from "../../../../../../hooks/theme"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { icons } from "../../../../../../utils/icons"
import { InputModel } from "../../../../../../utils/types"
import { FiltersFloat } from "../../../../../logbook/pages/main/components/access/components/filtersFloat"
import { FilterBody } from "../../../../../../hooks/filter/typing"

export const TableUserSolicited = ({
    handleShowTable,
    isLoadingTable,
    row,
    handleAddUsersSolicited,
    inputUser,
    userFilter,
    searchUsersSolicited,
    column
}: {
    row?: any;
    handleShowTable: (value: boolean) => void;
    isLoadingTable?: boolean;
    handleAddUsersSolicited?: () => void;
    inputUser: {
        [x: string]: InputModel;
    };
    userFilter: FilterBody;
    searchUsersSolicited: ({ all }: {
        all: boolean;
    }) => Promise<void>;
    column: {
        id: string;
        label?: string;
        minWidth?: number;
        column?: () => JSX.Element;
        renderCell?: (params: any) => JSX.Element;
    }[]
}) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const refTable = useRef<RefTable>(null)
    const { colors } = useContextState()
    const { cleanFilter, counter, errors,filterData, onChange} = userFilter;

    const handleCleanFilter = () => {
        cleanFilter()
        searchUsersSolicited({all:false})
    }

    return (
        <Box>
            <Box sx={styles.containerTitle}>
                <Typography sx={styles.title}>{t('filesManager.subtitles.selectUsersToAssignHowSolicited')}</Typography>

                <Box sx={styles.containerFilter}>
                    <Box sx={styles.drawerfilter}>
                        <FiltersFloat title={t('general.filterBy')} cleanFilter={handleCleanFilter} count={counter} right={-87} top={0} searchButton={{ disabled: false/* !userFilter.query?.filter */, loading: false, onClick: ()=>{ searchUsersSolicited({all:true}); } }}>
                            <DinamicForm input={Object.values(inputUser)} onChange={onChange} errors={errors} values={filterData} />
                        </FiltersFloat>
                    </Box>

                    <IconButton
                        sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            handleCleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                </Box>
            </Box>

            <Box sx={styles.containerButtons}>
                <Button sx={styles.cancelButton} onClick={() => { handleShowTable(false) }}>{t('general.cancel')}</Button>

                <Button className="next" variant="contained"
                    onClick={() => {
                        handleShowTable(false);
                        if (handleAddUsersSolicited) {
                            handleAddUsersSolicited()
                        }
                    }}>
                    {t('general.save')}
                </Button>
            </Box>

            <Box>
                <CustomTable
                    ref={refTable}
                    loader={isLoadingTable}
                    dontRefresh
                    column={column}
                    row={row ?? []}
                    color={colors}
                    selected={-1}
                />
            </Box>
        </Box>
    )
}